import { useState, useEffect } from "react";
const getMonthCountOfDays = (month, year) => new Date(year, month, 0).getDate();
const getMonthStartLocalDay = (month, year) => new Date(year, month - 1, 1).getDay();
export const useMonth = (month, year) => {
    const [countOfDays, setCountOfDays] = useState(0);
    const [startLocalDay, setStartLocalDay] = useState(0);
    useEffect(() => {
        setCountOfDays(getMonthCountOfDays(month, year));
        setStartLocalDay(getMonthStartLocalDay(month, year));
    }, [setCountOfDays, getMonthCountOfDays, month, year]);
    return {
        countOfDays,
        startLocalDay,
    };
};
